const state = () => ({
  name: null,
  langPrefix: null,
  isActive: null
});

const getters = {
  name(state) {
    return state.name;
  },
  langPrefix(state) {
    return state.langPrefix;
  },
  isActive(state) {
    return state.isActive;
  }
};

const mutations = {
  setName(state, payload) {
    state.name = payload;
  },
  setLangPrefix(state, payload) {
    state.langPrefix = payload;
  },
  setIsActive(state, payload) {
    state.isActive = payload;
  }
};

const actions = {
  setName({ commit }, payload) {
    const nameCamelized = (payload || 'hrajemeDal052022').replace(/-./g, substring =>
      substring[1].toUpperCase()
    );
    commit('setName', nameCamelized);
    commit('setLangPrefix', `conference.${nameCamelized}`);
    commit(
      'setIsActive',
      nameCamelized === 'hrajemeDal052022' && new Date() < new Date(2022, 5, 19, 23, 59, 59, 999)
    );
    return `conference.${nameCamelized}`;
  }
};

export const conference = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
